import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './SaudagarInfoModal.css';
import gobizLogoUrl from './gobiz-logo.png';
import mokaLogoUrl from './moka-logo.png';

function InfoCard(props) {
  const { logo, productName, outletName, address, outletId } = props;
  const addressBlock = address
    .split(',')
    .map((part, index) => <div key={index}>{part.trim()}</div>);

  return (
    <div className={styles.infoCard}>
      <div className={styles.infoCardRow}>
        <div className={styles.infoCardKeyColumn}>{logo}</div>
        <div className={styles.infoCardValueColumn}>
          <b>{productName}</b>
        </div>
      </div>

      <div className={styles.infoCardRow}>
        <div className={styles.infoCardKeyColumn}>Outlet Name</div>
        <div className={styles.infoCardValueColumn}>{outletName}</div>
      </div>

      <div
        className={classNames(styles.infoCardRow, styles.infoCardAddressRow)}
      >
        <div className={styles.infoCardKeyColumn}>Address</div>
        <div className={styles.infoCardValueColumn}>{addressBlock}</div>
      </div>

      <div className={styles.infoCardRow}>
        <div className={styles.infoCardKeyColumn}>Outlet ID</div>
        <div className={styles.infoCardValueColumn}>{outletId}</div>
      </div>
    </div>
  );
}

class SaudagarInfoModal extends Component {
  render() {
    const { moka, saudagar, onClose } = this.props;

    return (
      <Modal show>
        <Modal.Header>
          <Modal.Title>Outlet Association</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>This outlet is associated with a GoBiz outlet</div>

          <div className={styles.infoRow}>
            <InfoCard
              logo={<img src={mokaLogoUrl} alt="Moka Logo" />}
              productName="Moka"
              outletName={moka.name}
              address={moka.address}
              outletId={moka.id}
            />

            <InfoCard
              logo={<img src={gobizLogoUrl} alt="GoBiz Logo" />}
              productName="GoBiz"
              outletName={saudagar.name}
              address={saudagar.address}
              outletId={saudagar.id}
            />
          </div>

          <p className={styles.footNote}>
            If you have any concern about this, please call our customer service
            at <b>1500970</b>
          </p>
        </Modal.Body>

        <Modal.Footer className={styles.footer}>
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Got It
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SaudagarInfoModal.defaultProps = {
  moka: {},
  saudagar: {},
  onClose: () => {},
};

export default SaudagarInfoModal;
